/******************************
 * GENERATED FILE, DO NOT EDIT *
 *******************************/ import type {
  ReactNode,
  SVGProps,
} from "react";
export default function IconRoundedExclamationMark(
  props: SVGProps<SVGSVGElement>
): ReactNode {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16px"
      height="16px"
      fill="none"
      viewBox="0 0 17 17"
      color="currentColor"
      {...props}
    >
      <path
        fill="currentColor"
        d="M8.627 11.646a1.067 1.067 0 1 1 0 2.134 1.067 1.067 0 0 1 0-2.134M8.627 3.22c.472 0 .855.383.855.855v5.183a.856.856 0 0 1-1.71 0V4.075c0-.472.383-.855.855-.855"
      />
      <path
        fill="currentColor"
        d="M8.627 16.5a8 8 0 1 1 0-16 8 8 0 0 1 0 16m0-1.238a6.762 6.762 0 1 0 0-13.524 6.762 6.762 0 0 0 0 13.525"
      />
    </svg>
  );
}
